export interface ICampaignDetails {
  siteId: number;
  adsourceId: number;
  adsourceName: string;
  campaignId: number;
  campaignName: string;
  categoryTypeId: number;
  categoryTypeName: string;
  details: string;
}

export class CampaignDetailsModel implements ICampaignDetails {
  siteId: number = 0;
  adsourceId: number = 0;
  adsourceName: string = '';
  campaignId: number = 0;
  campaignName: string = '';
  categoryTypeId: number = 0;
  categoryTypeName: string = '';
  details: string = '';

  constructor(data: ICampaignDetails = {} as ICampaignDetails) {
    this.siteId = data?.siteId ?? this.siteId;
    this.adsourceId = data?.adsourceId ?? this.adsourceId;
    this.adsourceName = data?.adsourceName ?? this.adsourceName;
    this.campaignId = data?.campaignId ?? this.campaignId;
    this.campaignName = data?.campaignName ?? this.campaignName;
    this.categoryTypeId = data?.categoryTypeId ?? this.categoryTypeId;
    this.categoryTypeName = data?.categoryTypeName ?? this.categoryTypeName;
    this.details = data?.details ?? this.details;
  }
}
